export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const BE_BASE_URL = import.meta.env.VITE_BE_BASE_URL;
export const NODE_VERSION = import.meta.env.VITE_NODE_VERSION;
export const GRC_BASE_URL = import.meta.env.VITE_GRC_BASE_URL;